import React, { Component } from 'react';

import './AbstractMapView.css';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/leaflet.markercluster.js';

import { MarkerClusterGroup, DivIcon } from 'leaflet';
import Map from '../components/mapa/Map';
import firebase from '../util/firebase';

export default class AbstractMapView extends Component {
  componentWillMount() {
   
    this.markerLayers = new MarkerClusterGroup({
      iconCreateFunction(cluster) {
        var alertas = 0;
        var cameras = 0;
        var pulses = 0;

        cluster.getAllChildMarkers().map(marker => {
          marker.options.id === "pulse-marker" && pulses++;
          marker.options.alerta ? alertas++ : cameras++;
        });

        if(pulses > 0){
          return new DivIcon({
            className: 'count-marker',
            html: 
            `<div>
            <img src="/images/mapa/pin_grupo_ativo.svg" style="width: 100px;" class="marker" />
            <div class="counter" style="display: flex; flex-direction: column">
              <div>${cameras}</div>
              <div>${alertas}</div>
            </div>
            
          </div>`
          });
        }else{  
          return new DivIcon({
            className: 'count-marker',
            html: 
            `
              <div>
                <img src="/images/mapa/pin_grupo.svg" style="width: 100px;" class="marker" />
                <div class="counter" style="display: flex; flex-direction: column">
                  <div>${cameras}</div>
                  <div>${alertas}</div>
                </div>
                
              </div>`
          });

        }

      }
    })
    this.registerListener();
  }

  componentWillUnmount() {
    this.unregisterListener();
  }

  viajarAte(coords, zoom){
    this.map.flyTo(coords, zoom);
  }

  componentDidMount() {
    let ref = firebase.database().ref("cameras-localizacao/");
    ref.on('value', cameras => {
      let mapStarted = false;
      cameras.forEach(camera => {
        if (!mapStarted) {
          console.log(camera.val());
          mapStarted = true;
          this.map = Map('main-map', camera.val().l);
          this.map.modalLocalizacaoHandler = this.props.abreModalLocalizacao;
        }
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.raio && nextProps.localizacao &&
       (this.props.raio !== nextProps.raio || this.props.localizacao !== nextProps.localizacao)) {
      const query = {
        center: nextProps.localizacao,
        radius: nextProps.raio
      };
      this.props.atualizaLocalizacaoAlertas(query);
      this.props.atualizaLocalizacaoCameras(query);
    }

    return new Promise((resolve, reject) => {
      clearTimeout(this.debouncer);
      this.debouncer = setTimeout(() => {
        if(Object.keys(nextProps.cameraSelecionada).length === 0){
          this.updateMarkersLayer(nextProps);
          if (this.markerLayers.getLayers().length > 0) {
            this.markerLayers.addTo(this.map);
            this.map.fitBounds(this.markerLayers.getBounds());
          }
        }
        return resolve();
      }, 200);
    })
   
  }

  render() {
    return <div id="main-map"></div>;
  }

 
}



// WEBPACK FOOTER //
// ./src/containers/AbstractMapView.js